import { Component, ElementRef, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { Settings } from '../data/models';
import { APP_SETTINGS } from '../data/settings-data.provider';

@Component({
    selector: 'app-product-collection-select',
    template: `
    <div class="d-flex justify-content-between align-items-center">
      <button class="btn btn-outline-primary border-0 bg-light px-2 py-0 me-1" (click)="scroll('left')">
        <span class="material-icons">keyboard_arrow_left</span>
      </button>
      <button class="btn rounded-pill px-3 py-2 mx-1 btn-focus-no-shadow text-nowrap"
              [class]="!selectedCollection ? 'btn-primary' : 'btn-light'"
              (click)="selectCollection(null)" i18n>Alle Produkte
      </button>
      <div class="horizontal-scroll-wrapper text-nowrap align-items-center" #collectionsContainer>
        <button *ngFor="let collection of settings.collections"
                class="btn border border-1 rounded-pill px-3 py-2 mx-1 btn-focus-no-shadow"
                [class]="collection.id === selectedCollection ? 'btn-primary' : 'btn-light'"
                (click)="selectCollection(collection.id)">
          {{collection.title}}
        </button>
      </div>
      <button class="btn btn-outline-primary border-0 bg-light px-2 py-0 ms-1" (click)="scroll('right')">
        <span class="material-icons">keyboard_arrow_right</span>
      </button>
    </div>
  `,
    styles: [`
    .horizontal-scroll-wrapper {
      overflow-x: auto;
      text-wrap: none;
      width: 100%;
    }

    .horizontal-scroll-wrapper {
      scrollbar-width: none;
    }
    .horizontal-scroll-wrapper::-webkit-scrollbar {
      width: 1px;
      height: 1px;
    }
  `],
    standalone: false
})
export class ProductCollectionSelectComponent {
  @Output() collectionChange: EventEmitter<number | null> = new EventEmitter<number | null>();

  @ViewChild('collectionsContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  selectedCollection: number | null = null;

  constructor(@Inject(APP_SETTINGS) public settings: Settings) {
  }

  selectCollection(collectionId: number | null) {
    if (this.selectedCollection === collectionId) {
      this.selectedCollection = null;
    }

    this.selectedCollection = collectionId;
    this.collectionChange.emit(this.selectedCollection);
  }

  scroll(direction: 'left' | 'right') {
    const scrollStep = 150;
    const scrollBy = direction === 'right' ? scrollStep : -scrollStep;
    this.scrollContainer.nativeElement.scrollBy({ left: scrollBy });
  }
}
